/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { JobTemplate } from '../models/JobTemplate';

export class ListJobTemplatesResponse {
  /**
  * List of job templates
  */
  'jobTemplates': Array<JobTemplate>;
  /**
  * Token to retrieve the next page of results
  */
  'nextToken'?: string | null;
  /**
  * Total number of job templates matching the filter
  */
  'totalCount'?: number | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "jobTemplates",
      "baseName": "jobTemplates",
      "type": "Array<JobTemplate>",
      "format": ""
    },
    {
      "name": "nextToken",
      "baseName": "nextToken",
      "type": "string",
      "format": ""
    },
    {
      "name": "totalCount",
      "baseName": "totalCount",
      "type": "number",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListJobTemplatesResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

